import PropTypes from 'prop-types';
import { Flex, Paragraph } from '@zillow/constellation';
import { format, parse } from 'date-fns';
import ContactInfo from '../ContactInfo';
import ClampedText from '../../../../../../components/ClampedText';

export const NO_DATE_INFO_MSG = 'No date information provided';

export function formatDateString(startDate, endDate) {
  if (!startDate && !endDate) {
    return NO_DATE_INFO_MSG;
  }
  const startDateAsString = format(parse(startDate), 'MMM YYYY');
  const endDateAsString = endDate ? format(parse(endDate), 'MMM YYYY') : 'present';
  return `${startDateAsString} - ${endDateAsString}`;
}

export default function HistorySection({ startDate, endDate, heading, body, contactInfo, className = null }) {
  const bodyArray = Array.isArray(body) ? body : [body];
  const bodyComponents = bodyArray.filter(Boolean).map((bodyString) => (
    <ClampedText maxLines={2} fontType="body" key={bodyString}>
      {bodyString}
    </ClampedText>
  ));
  return (
    <Flex id="history-section" display="flex" flexDirection="column" className={className}>
      <Paragraph fontType="bodySmallHeading">{formatDateString(startDate, endDate)}</Paragraph>
      <ClampedText maxLines={2} fontType="bodySmallHeading">
        {heading}
      </ClampedText>
      {bodyComponents}
      {contactInfo && (
        <ContactInfo
          marginTop={3}
          title={contactInfo.title}
          name={contactInfo.name}
          phone={contactInfo.phone}
          email={contactInfo.email}
        />
      )}
    </Flex>
  );
}

HistorySection.propTypes = {
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  heading: PropTypes.string,
  body: PropTypes.node,
  contactInfo: PropTypes.shape({
    title: PropTypes.string,
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
  className: PropTypes.string,
};
